import {Component, OnInit, ViewChild} from '@angular/core';
import {StoreService} from "../../store.service";
import {CdkDrag, CdkDragMove, CdkDropList, CdkDropListGroup, moveItemInArray} from "@angular/cdk/drag-drop";
import {ModalDismissReasons, NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {UtilitiesService} from "../../core/utilities.service";
import {ViewportRuler} from "@angular/cdk/scrolling";
import {Router} from "@angular/router";

declare const $: any;

@Component({
  selector: 'app-product-faq',
  templateUrl: './product-faq.component.html',
  styleUrls: ['./product-faq.component.scss']
})
export class ProductFaqComponent implements OnInit {
  @ViewChild(CdkDropListGroup) listGroup: CdkDropListGroup<CdkDropList>;
  @ViewChild(CdkDropList) placeholder: CdkDropList;

  public target: CdkDropList;
  public targetIndex: number;
  public source: CdkDropList;
  public sourceIndex: number;
  public dragIndex: number;
  public activeContainer;

  public initialArrangement = []; // Initially loaded or unchanged arrangement
  public productFaqArrangement = []; // Arrangement state for current listing
  public customArrangement = []; // Arrangement from backend, multi country
  productFaqArrangementReady = false;
  customArrangementReady = false;
  isSavingArrangement = false;

  updatingDisplayQueue = [];
  pageList = [];
  pagePaginationList = [];

  filteredString: string = '';
  filteredCountry: string = '';
  filteredStatus: string = '';
  filteredStatusDisplay: string = '';

  imgURL: any;

  bearer;
  storeId;
  products = [];
  productFaqs = [];
  country;

  closeResult = '';

  title;
  caption;
  alt_text;
  filesize;

  pageName;
  duplicatedPage;

  displayedProducts = [];
  displayedProductsFaqs = [];
  expanded = [];
  page = 1;
  itemPerPage = 10;
  start = 0;
  end = 0;
  loading = true;
  loadingInfo = true;

  success;
  body = [];
  store_id;
  product_id;
  language_code;
  product_name;
  product_overview;
  product_desc;
  primary_photo;
  language;
  language_name;
  //language_code ='en_US';

  errorMsg = '';

  constructor(
      private svc: StoreService,
      private modalService: NgbModal,
      private utils: UtilitiesService,
      private viewportRuler: ViewportRuler,
      private router: Router
  ) {
    this.target = null;
    this.source = null;
  }

  ngOnInit(): void {
    this.bearer = localStorage.getItem('bearer');
    this.store_id = localStorage.getItem('store_id');

    $.trumbowyg.svgPath = '/library/trumbowyg-dist/ui/icons.svg';
    setTimeout(() => {
      $('.text-textarea').trumbowyg();
    }, 10);

    this.fetchCountry();
    this.fetchProductList();
  }

  private reloadProductFaqList(language = 'ALL', isReloadInitial = true): void {
    console.log('reloadProductFaqList');

    this.svc.getProductFaqLists(this.bearer, this.store_id, language).subscribe(
      (res) => {
        const productFaqList = res['data'];

        if (productFaqList.length > 0) {
          productFaqList.sort((a, b) => {
            return a.position - b.position;
          }).forEach((item) => {
            const languages = this.language.find(lang => lang.language_code === item.language_code);
            item.language_name = languages ? languages.language_name : undefined;
          });

          this.productFaqs = productFaqList;
          this.loading = false;
          this.updateFilter();

          if (isReloadInitial) {
            this.initialArrangementList();
            this.generateArrangementList();
          }

        } else {
          this.loading = false;
          this.router.navigateByUrl('/dashboard/product-faq/create');
        }

      },
      (error) => {
        this.loading = false;
      }
    );
  }

  private fetchProductList(): void {
    this.loading = true;

    this.svc.getStoreLanguage(this.bearer, this.store_id).subscribe(
        (res) => {
          const allLanguages = res['data'];

          const enabledLanguages = [{language_code: 'ALL', language_name: 'View All'}];

          allLanguages.forEach((lang) => {
            if(+lang.status) {
              enabledLanguages.push(lang);
            }
          });

          const defaultLanguage = enabledLanguages.find((lang) => lang.language_code === 'ALL') ?? allLanguages[0];

          this.language = enabledLanguages;
          this.language_code = defaultLanguage['language_code'];
          this.language_name = defaultLanguage['language_name'];

          this.reloadProductList();
          this.reloadProductFaqList();
        },
        (error) => {
          this.loading = false;
        }
    );
  }

  private reloadProductList(): void {
    console.log('reloadProductList');
    this.svc
        .getProductLists(this.bearer, this.store_id, this.language_code)
        .subscribe((res) => {
          this.products = res['data'];
          this.loading = false;
          // console.log('product list trace',productList)
        });
  }

  private saveLastArrangementListChanged(arrangementList = []): void {
    const customNewArrangement = [];

    arrangementList.sort((a,b) => a.position - b.position)
      .forEach((item) => {
        customNewArrangement.push({id: item.id, position: item.position});
      });

    this.customArrangement = this.sliceRecord(customNewArrangement);
    this.productFaqArrangement = this.sliceRecord(customNewArrangement);
  }

  public saveProductFaqArrangement(event): void {
    this.isSavingArrangement = true;
    const { customArrangement, productFaqArrangement} = this;

    customArrangement.forEach((A, index) => {
      if (A !== productFaqArrangement[index]) {
        if (A.position !== productFaqArrangement[index].position) {
          A.previous_position = A.position;
          A.position = productFaqArrangement[index].position;
        }
      }
    });

    const body = {
      newArrangement: customArrangement
    };

    this.svc.putFaqPosition(this.bearer, body).subscribe(
      (res) => {
        this.isSavingArrangement = false;
        this.saveLastArrangementListChanged(res?.['data']);
        this.reloadProductFaqList('ALL', false);
      },
      (error) => {
        console.log(error);
      }
    );

  }

  private initialArrangementList(): void {
    const initialFaqsArrangement = [];

    if (this.productFaqs.length > 0) {
      this.productFaqs.sort((a, b) => a.position - b.position).forEach((item) => {
        initialFaqsArrangement.push({id: item.id, position: item.position});
      });
    }

    this.productFaqArrangement = this.sliceRecord(initialFaqsArrangement);
  }

  private generateArrangementList(isTriggered = false): void {
    const productFaqsArrangement = [];

    this.displayedProductsFaqs.forEach(
      (faq: any) => {
        const { id, position } = faq;
        productFaqsArrangement.push({id, position});
      }
    );

    if (isTriggered) {
      this.productFaqArrangement = this.sliceRecord(productFaqsArrangement);
    }

    this.customArrangement = this.sliceRecord(productFaqsArrangement);
    this.customArrangementReady = true;
  }

  get isArrangementModified(): boolean {
    const { productFaqArrangement, customArrangement } = this;
    let changes = false;

    if(productFaqArrangement.length === 0 || customArrangement.length === 0) {
      return false;
    }

    productFaqArrangement.forEach((itemFaq, index) => {
      const indexCustom = customArrangement.findIndex((item) => item.id === itemFaq.id && item.position === itemFaq.position);
      if (indexCustom !== index) {
        changes = true;
      }
    });

    return changes;
  }

  public changeLanguage(languageCode, languageName): void {
    this.displayedProductsFaqs = null;
    this.language_code = languageCode;
    this.language_name = languageName;
    this.updateFilter();
    this.generateArrangementList(true);
  }

  public changeCountry(countryCode): void {
    this.filteredCountry = countryCode;
    this.updateFilter();
    this.generateArrangementList(true);
  }

  private fetchCountry(): void {
    this.svc.getCountry(this.bearer).subscribe((res) => {
      res['data'].forEach((item) => {
        if (item['country_name'] == 'Malaysia-Brunei') {
          item['country_name'] = 'Brunei';
        }
      });

      this.country = [{ country_code: 'ALL', country_name: 'All Countries' }];
      this.filteredCountry = 'ALL';
      if (res['data']) {
        res['data'].forEach((value) => {
          value.country_name = value.country_name.split('-').pop().trim();
          this.country.push(value);
        });
      }
    });
  }

  getFlagByCountryCode(country_code: string) {
    country_code = (country_code || '').toLowerCase().substr(-2, 2);
    country_code = country_code === 'cm' ? 'kh' : country_code;
    return country_code;
  }

  getFlagImageURL(country_code: string) {
    if (!country_code || country_code === 'ALL') return '';
    country_code = this.getFlagByCountryCode(country_code);
    return `https://cdn.estore5s.com/asset/flags/${country_code}.png`;
  }

  clearProductFaqSearch() {
    this.filteredString = '';
    this.updateFilter();
  }

  openModal(content) {
    this.modalService
        .open(content, {
          ariaLabelledBy: 'modal-basic-title',
          size: 'lg',
          backdrop: 'static',
          keyboard: false,
          windowClass: 'modal-customer',
          centered: true,
        })
        .result.then(
        (result) => {
          this.closeResult = `Closed with: ${result}`;
        },
        (reason) => {
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        }
    );
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  public getCountryName(countryCode: string): string {
    if (countryCode === 'ALL' || !countryCode) {
      return 'All Countries';
    }
    countryCode = (countryCode || '').toLowerCase();
    const country = this.country?.find(
        (c) => (c.country_code || '').toLowerCase() === countryCode
    );

    return country?.country_name ?? countryCode;
  }

  private filterProductFaq(productFaqs: any, filterString: any) {
    if (!productFaqs || productFaqs.length === 0) {
      return productFaqs;
    }

    return productFaqs.filter((product: any) => {
      // Filter by search query
      const keywordsFilter = filterString[0].toLowerCase().split(' ');
      const keywordsFilterResult = keywordsFilter.every(
          (keyword) => {
            let productName = product.product_name;
            let searchHaystack = `${product.title}`;

            if(typeof productName !== 'undefined') {
              searchHaystack = searchHaystack + ` ${productName}`;
            }

            return searchHaystack.toLowerCase().indexOf(keyword) >= 0;
          }
      );

      // Filter by country
      const countryFilter = filterString[1];
      const countryFilterResult =
          countryFilter === 'ALL' || product['country_code'] === countryFilter;

      // Filter by language
      const languageFilter = filterString[2];
      const languageFilterResult =
          languageFilter === 'ALL' || product['language_code'] === languageFilter;

      return keywordsFilterResult && countryFilterResult && languageFilterResult;
    }).sort((a, b) => {
      return a.position - b.position;
    });
  }

  public updateFilter(event = null): void {
    const filteredFaqs = this.filterProductFaq(this.productFaqs, [
      this.filteredString,
      this.filteredCountry,
      this.language_code
    ]);
    this.displayedProductsFaqs = filteredFaqs;
  }

  getDisplayedProductsFaqs() {
    return this.sliceRecord(this.displayedProductsFaqs);
  }

  selectPage(page: any) {
    this.itemPerPage = page;
    this.page = 1;
  }

  changePage(pageOfItems) {
    const slicedArrangement = [];
    this.page = pageOfItems;
    this.updateFilter();
    const slicedRecord = this.sliceRecord(this.displayedProductsFaqs);

    slicedRecord.sort((a, b) => {
      return a.position - b.position;
    }).forEach((record) => {
      slicedArrangement.push({id: record.id, position: record.position});
    });

    this.productFaqArrangement = slicedArrangement;
    this.customArrangement = slicedArrangement;
  }

  sliceRecord(data) {
    this.start = Math.round((this.page - 1) * this.itemPerPage);
    this.end = this.start + this.itemPerPage;
    this.end =
      this.end > data.length
        ? data.length
        : this.end;
    this.end = this.end > this.start ? this.end : this.start;
    return  data.slice(
      this.start,
      this.end
    );
  }

  openModalContent(image) {
    this.modalService
        .open(image, {
          ariaLabelledBy: 'modal-basic-title',
          size: 'lg',
          windowClass: 'modal-customer',
          centered: true,
        })
        .result.then(
        (result) => {
          this.closeResult = `Closed with: ${result}`;
        },
        (reason) => {
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        }
    );
  }

  /*
  Drag & Drop logic
  */
  ngAfterViewInit() {
    if(typeof this.placeholder !== 'undefined') {
      let phElement = this.placeholder.element.nativeElement;
      phElement.style.display = 'none';
      phElement.parentElement.removeChild(phElement);
    }
  }

  dragMoved(e: CdkDragMove) {
    let point = this.getPointerPositionOnPage(e.event);

    this.listGroup._items.forEach((dropList) => {
      if (__isInsideDropListClientRect(dropList, point.x, point.y)) {
        let sourceId = e.source.dropContainer.id;
        let targetId = dropList.id;

        // console.log('dropList', dropList);
        this.activeContainer = dropList;
        // dropList.element.nativeElement.style.backgroundColor = '#7744ff7a';
        let childrenList =
            e.source.dropContainer.element.nativeElement.parentElement.children;
        let sourceEl: any = e.source.dropContainer.element.nativeElement;
        let targetEl: any = e.source.dropContainer.element.nativeElement;

        let sourceIndex = -1;
        let targetIndex = -1;

        [...(childrenList as any)].forEach((child, index) => {
          const listIndex = index + (this.itemPerPage * (this.page - 1));
          if (child.id === sourceId) sourceIndex = listIndex;
          if (child.id === targetId) targetIndex = listIndex;
        });

        if (targetIndex !== sourceIndex) {
          // console.log({ sourceIndex, targetIndex });
          // console.log({ sourceId, targetId });
          console.log('Moving', sourceIndex, targetIndex);
          moveItemInArray(this.displayedProductsFaqs, sourceIndex, targetIndex);
        }
        return;
      }
    });
  }

  dragDropped(e: CdkDragMove) {
    console.log('dragDropped', e);
    this.generateArrangementList();
  }

  dropListEnterPredicate = (drag: CdkDrag, drop: CdkDropList) => {

    if (drop == this.placeholder) return true;
    if (drop != this.activeContainer) return false;

    return false;
  };

  /** Determines the point of the page that was touched by the user. */
  getPointerPositionOnPage(event: MouseEvent | TouchEvent) {
    // `touches` will be empty for start/end events so we have to fall back to `changedTouches`.
    const point = __isTouchEvent(event)
        ? event.touches[0] || event.changedTouches[0]
        : event;
    const scrollPosition = this.viewportRuler.getViewportScrollPosition();

    return {
      x: point.pageX - scrollPosition.left,
      y: point.pageY - scrollPosition.top,
    };
  }

  private static getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  getPageName(id) {
    let filteredPageList = this.displayedProductsFaqs.filter(
        (item) => item.id === id
    );
    this.pageName = filteredPageList[0].title;
  }

  getPageListing() {
    this.loading = true;
    this.svc.getPageList(this.bearer, this.storeId).subscribe((res) => {
      let me = this;
      me.pageList = res['data']?.reverse();
      if (me.pageList.length <= 0) {
        this.loading = false;
      } else {
        this.loading = false;
        this.sliceCart();
      }
    });
  }

  open(content, id) {
    this.getPageName(id);
    this.modalService
        .open(content, {
          ariaLabelledBy: 'modal-basic-title',
          centered: true,
          backdrop: 'static',
        })
        .result.then(
        (result) => {
          if (result == 'delete') {
            this.deleteFaq(id);
            this.closeResult = `Closed with: ${result}`;
          }
          if (result == 'submit') {
            this.loading = true;
            this.duplicatedPage = true;
            localStorage.setItem('duplicateFaq', this.duplicatedPage);
            this.svc.postDuplicateFaq(id, this.bearer).subscribe(
                (res) => {
                  // let returnProductFaqId = res['data']['id'];
                  // this.edit(returnProductFaqId);
                  setTimeout(() => {
                    this.utils.notify.showSuccess(this.utils.translate("FAQs Successfully Duplicated"));
                    this.reloadProductFaqList();
                  }, 2000);
                },
                (error) => {
                  console.log(error,);
                  this.loading = false;
                  this.utils.notify.showError(error['error']['message']);
                }
            );
          }
        },
        (reason) => {
          this.closeResult = `Dismissed ${ProductFaqComponent.getDismissReason(
              reason
          )}`;
        }
    );
  }

  deleteFaq(id) {
    this.loading = true;
    this.svc.postDeleteFaq(id,this.bearer).subscribe(
        (res) => {
          console.log(res);
          setTimeout(() => {
            this.utils.notify.showSuccess(this.utils.translate("Product FAQs successfully Deleted"));
            this.reloadProductFaqList();
          }, 2000);
        },
        (error) => {
          console.log(error);
          this.utils.notify.showError(this.utils.translate("Delete failed!"));
        }
    );
  }

  edit(id) {
    this.router.navigateByUrl('/dashboard/product-faq/edit/' + id);
  }

  sliceCart() {
    this.start = Math.round((this.page - 1) * this.itemPerPage);
    this.end = this.start + this.itemPerPage;
    this.end =
        this.end > this.pageList.length ? this.pageList.length : this.end;
    this.end = this.end > this.start ? this.end : this.start;
    this.pagePaginationList = this.pageList.slice(this.start, this.end);
    if (this.pagePaginationList.length > 0) {
      this.pagePaginationList.forEach((value, index) => {
        this.expanded[index] = false;
      });
    }
  }
}

function __indexOf(collection, node) {
  return Array.prototype.indexOf.call(collection, node);
}

/** Determines whether an event is a touch event. */
function __isTouchEvent(event: MouseEvent | TouchEvent): event is TouchEvent {
  return event.type.startsWith('touch');
}

function __isInsideDropListClientRect(
    dropList: CdkDropList,
    x: number,
    y: number
) {
  const { top, bottom, left, right } =
      dropList.element.nativeElement.getBoundingClientRect();
  return y >= top && y <= bottom && x >= left && x <= right;
}
